import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import staticURL from 'lib/staticURL';
import * as Colors from 'ui-library/Colors';

import {AvailabilityToShow} from './swagger-ui/constants';
import SwaggerDropdown from './swagger-ui/SwaggerDropdown';
interface Props {
  updateDropdown?: (version: string, availabilityToShow: AvailabilityToShow) => void;
  dropdownLabel?: string;
}

export default function SwaggerUiPageHeader(props: Props): JSX.Element {
  const {updateDropdown, dropdownLabel} = props;
  return (
    <div className={classNames(css(styles.container))}>
      <div className={classNames(css(styles.contentWrapper))}>
        <div className={classNames(css(styles.flexBox))}>
          <div className={classNames(css(styles.headerChild))}>
            <a href="/">
              <img
                className={classNames(css(styles.logo))}
                src={staticURL('/static/img/logo_250_notext.png')}
                alt="Benchling logo"
              />
            </a>
          </div>
          <div className={classNames(css(styles.headerChild))}>
            <a target="_blank" rel="noopener noreferrer" href="https://docs.benchling.com">
              Warehouse & API Guide
            </a>
          </div>
          <div className={classNames(css(styles.headerChild))}>
            <a target="_blank" rel="noopener noreferrer" href="https://benchling.com/sdk-docs/">
              SDK Reference
            </a>
          </div>
          <div className={classNames(css(styles.headerChild))}>
            <a target="_blank" rel="noopener noreferrer" href="https://benchling.com/api/reference">
              Public API Reference
            </a>
          </div>
          <div className={classNames(css(styles.headerChild))}>
            <a target="_blank" rel="noopener noreferrer" href="https://benchling.com/webhooks/reference">
              Webhooks Reference
            </a>
          </div>
          {updateDropdown && dropdownLabel ? (
            <div className={classNames(css(styles.headerChild))}>
              <SwaggerDropdown updateDropdown={updateDropdown} dropdownLabel={dropdownLabel} />
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
}
const styles = StyleSheet.create({
  container: {
    height: '10%',
    borderBottom: `2px solid ${Colors.BLUE_LIGHT}`,
  },
  flexBox: {
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'center',
  },
  headerChild: {
    margin: 'auto 10px',
  },
  logo: {
    height: '40px',
    width: '40px',
  },
  contentWrapper: {
    margin: '40px auto',
    width: '90%',
    maxWidth: '1300px',
  },
});
